<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-card elevation="8" class="pa-8" rounded="lg">
                    <div v-if="store.isLoggedIn" class="text-center">
                        <v-icon size="80" color="success" class="mb-4">mdi-check-circle</v-icon>
                        <h1 class="text-h4 mb-4">{{ $t('login.welcome_back') }}</h1>
                        <p class="text-body-1 text-medium-emphasis mb-6">{{ $t('login.you_are_logged_in') }}</p>
                        <v-btn
                            @click="onLogout()"
                            variant="tonal"
                            size="large"
                            prepend-icon="mdi-logout"
                            block
                        >
                            {{ $t('login.logout') }}
                        </v-btn>
                    </div>

                    <div v-else>
                        <div class="text-center mb-8">
                            <h1 class="text-h4 mb-2">{{ $t('login.welcome') }}</h1>
                            <p class="text-body-2 text-medium-emphasis">{{ $t('login.sign_in_or_create_an_account_with_google') }}</p>
                        </div>

                        <div class="d-flex justify-center mb-8">
                            <GoogleLogin
                                :callback="callback"
                                :button-config="{ text: 'continue_with' }"
                            />
                        </div>

                        <v-divider class="my-8"></v-divider>

                        <div v-if="isDevelopment">
                            <div class="text-center mb-4">
                                <p class="text-caption text-medium-emphasis">{{ $t('login.development_only') }}</p>
                                DEV Mode: {{ devMode }}
                            </div>

                            <v-btn
                                color="error"
                                @click="onFakeLogin('psychologist')"
                                variant="outlined"
                                prepend-icon="mdi-account-circle"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_alex') }}
                            </v-btn>

                            <v-btn
                                color="error"
                                @click="onFakeLogin2('psychologist')"
                                variant="outlined"
                                prepend-icon="mdi-account-circle"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_freud') }}
                            </v-btn>

                            <v-btn
                                color="warning"
                                @click="onFakeLogin('client')"
                                variant="outlined"
                                prepend-icon="mdi-account"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_client') }}
                            </v-btn>

                            <!-- <v-btn
                                color="warning"
                                @click="onClearCredentials()"
                                variant="outlined"
                                prepend-icon="mdi-account"
                                block
                            >
                                {{ $t('login.clear_credentials') }}
                            </v-btn> -->
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { appStore } from '@/stores/AppStore'
import envMixin from '@/mixins/envMixin'

export default {
    name: 'LoginView',
    mixins: [envMixin],
    data() {
        return {            
        };
    },
    computed: {
        store() {
            return appStore();
        },
        // isLoggedIn() {
        //     return this.store.isLoggedIn;
        // }
    },
    created() {
        // this.store.initAuth();
    },
    methods: {
        updateLanguage(newLang){
            // Save to local storage and update i18n
            localStorage.setItem('user-language', newLang);
            this.$i18n.locale = newLang;
        },

        //Step 1. This callback will be triggered when the user selects or login to
        // his Google account from the popup
        callback (response) {
            
            console.log("LoginView > callback > response", response)

            const api_url = process.env.VUE_APP_API_ENDPOINT;
            const google_url = `${api_url}/auth/google`;
            console.log("LoginView > callback > Google URL:", google_url);

            // Step 2. Send the Google credential token to your backend
            fetch(google_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: response.credential })
                // body: JSON.stringify({ token: "nothing" })
            })

            //Step 3. Your backend will validate the token and return your own JWT token
            .then(res => res.json())

            // Step 4. Now we have response decoded as JSON. Save the token in your store (or localStorage)
            .then(data => {
                console.log('LoginView > callback > Backend response:', data);
                // Backend returns your own JWT token

                // appStore.setAuth(token, { email, name })

                this.store.setToken(data.token);
                this.store.setUser(data.user);
                this.updateLanguage(data.user.language)

                console.log("LoginView > callback > User role:", data.user.role);
                switch(data.user.role) {
                    case 'therapist':
                    case 'psychologist':
                        this.$router.push('/psychologist/dashboard');
                        break;
                    case 'patient':
                    case 'client':
                        this.$router.push('/client/evaluations');
                        break;
                    default:
                        this.$router.push('/');
                }
                // No jwt-decode needed here
            });
        },

        onLogout() {
            console.log("Logging out");
            this.store.logout();
        },

        onFakeLogin(role){
            console.log("Fake login");

            const api_url = process.env.VUE_APP_API_ENDPOINT;
            const fake_login_url = `${api_url}/auth/fakeLogin`;
            console.log("Fake login URL:", fake_login_url);

            // Step 2. Send the Google credential token to your backend
            fetch(fake_login_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ role: role }) //nothing
                // body: JSON.stringify({ token: "nothing" })
            })

            //Step 3. Your backend will validate the token and return your own JWT token
            .then(res => res.json())

            // Step 4. Now we have response decoded as JSON. Save the token in your store (or localStorage)
            .then(data => {
                console.log('Backend response:', data);
                // Backend returns your own JWT token

                // appStore.setAuth(token, { email, name })

                this.store.setToken(data.token);
                this.store.setUser(data.user);
                this.updateLanguage(data.user.language)

                console.log("User role:", data.user.role);
                switch(data.user.role) {
                    case 'therapist':
                    case 'psychologist':
                        this.$router.push('/psychologist/dashboard');
                        break;
                    case 'patient':
                    case 'client':
                        this.$router.push('/client/evaluations');
                        break;
                    default:
                        this.$router.push('/');
                }
                // No jwt-decode needed here
            });
        },

        onFakeLogin2(role){
            console.log("Fake login");

            const api_url = process.env.VUE_APP_API_ENDPOINT;
            const fake_login_url = `${api_url}/auth/fakeLogin2`;
            console.log("Fake login URL:", fake_login_url);

            // Step 2. Send the Google credential token to your backend
            fetch(fake_login_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ role: role }) //nothing
                // body: JSON.stringify({ token: "nothing" })
            })

            //Step 3. Your backend will validate the token and return your own JWT token
            .then(res => res.json())

            // Step 4. Now we have response decoded as JSON. Save the token in your store (or localStorage)
            .then(data => {
                console.log('Backend response:', data);
                // Backend returns your own JWT token

                // appStore.setAuth(token, { email, name })

                this.store.setToken(data.token);
                this.store.setUser(data.user);
                this.updateLanguage(data.user.language)

                console.log("User role:", data.user.role);
                switch(data.user.role) {
                    case 'therapist':
                    case 'psychologist':
                        this.$router.push('/psychologist/dashboard');
                        break;
                    case 'patient':
                    case 'client':
                        this.$router.push('/client/evaluations');
                        break;
                    default:
                        this.$router.push('/');
                }
                // No jwt-decode needed here
            });
        },

        // onClearCredentials(){
        //     this.store.reset();
        // }
    }
}
</script>

<style scoped>
.welcome {
    text-align: center;
    padding: 2rem;
}
</style>